<template>
  <v-dialog
    v-model="signInDialog.visible"
    content-class="custom-dialog"
    width="65%"
  >
    <div class="d-flex login-dialog">
      <div class="login-logo"></div>
      <div class="d-flex flex-column flex-1 ai-center login">
        <div class="login-title" style="font-weight:bold;">
          <span>
            {{ $t("login.title1") }}
          </span>
          {{ $t("login.title2") }}
        </div>
        <div
          class="d-flex flex-column ai-center jc-between h-75 w-100"
          v-if="!isSignUp && !forgetPwd"
        >
          <v-form class="login-form">
            <v-text-field
              :disabled="loginLoading"
              :loading="loginLoading"
              :rules="[rules.required]"
              :placeholder="$t('login.accountPlaceholder')"
              @keydown.enter.exact="login"
              v-model="loginForm.account"
            ></v-text-field>
            <v-text-field
              :disabled="loginLoading"
              :loading="loginLoading"
              :rules="[rules.required]"
              :placeholder="$t('login.passwordPlaceholder')"
              @keydown.enter.exact="login"
              type="password"
              v-model="loginForm.password"
            ></v-text-field>
            <v-btn
              :loading="loginLoading"
              class="btn-login mt-4"
              color="primary"
              depressed
              @click="login"
            >
              {{ $t("login.login") }}
            </v-btn>
            <div class="d-flex jc-end mt-1">
              <v-btn text @click="forgetPwd = true">
                {{ $t("login.forgetPassword") }}
              </v-btn>
            </div>
          </v-form>
          <div class="d-flex w-70">
            <div class="d-flex flex-column">
              <span
                class="mb-1"
                v-ripple
                style="text-decoration: underline; cursor:pointer;"
                @click="clickSignUp"
                >{{ $t("login.newToHere") }}</span
              >
              <div class="d-flex flex-column ai-center">
                <span>
                  {{ $t("login.orSocialAccount") }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-1 pl-16">
              <div class="mx-9">
                <v-facebook-login
                  v-show="false"
                  :app-id="FBAppId"
                  :options="FBOptions"
                  v-model="FBmodel"
                  :sdk-locale="$i18n.locale"
                  @sdk-init="handleSdkInit"
                />
                <v-btn @click="fbLogin" icon width="3rem" height="3rem">
                  <img
                    src="/assets/ic/login/iconfinder_facebook.png"
                    alt="facebook-btn"
                  />
                </v-btn>
              </div>
              <div class="mx-6">
                <v-btn icon width="3rem" height="3rem">
                  <g-signin-button
                    class="d-flex"
                    :params="googleSignInParams"
                    @success="googleSignInSuccess"
                    @error="googleSignInError"
                  >
                    <img
                      src="/assets/ic/login/iconfinder_google-plus.png"
                      alt="google-plus"
                    />
                  </g-signin-button>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column jc-between h-75 ai-center"
          :class="{ hide: !isSignUp || forgetPwd }"
        >
          <v-form class="login-form" ref="signupForm" v-model="signupValid">
            <v-text-field
              :disabled="signupLoading"
              :loading="signupLoading"
              :rules="[rules.required, rules.validEmail]"
              :placeholder="$t('login.accountPlaceholder')"
              :error-messages="error409"
              @keydown.enter.exact="signup"
              @blur="checkConflict"
              v-model="signupForm.account"
            ></v-text-field>
            <v-text-field
              :disabled="signupLoading"
              :loading="signupLoading"
              :rules="[rules.required, rules.validPwd]"
              :placeholder="$t('login.passwordPlaceholder')"
              @keydown.enter.exact="signup"
              type="password"
              v-model="signupForm.password"
            ></v-text-field>
            <v-text-field
              :disabled="signupLoading"
              :loading="signupLoading"
              :rules="[rules.required, rules.repeatPwd]"
              :placeholder="$t('login.repeatPasswordPlaceholder')"
              @keydown.enter.exact="signup"
              type="password"
              v-model="signupForm.repeatPassword"
            ></v-text-field>
            <v-text-field
              :disabled="signupLoading"
              :loading="signupLoading"
              :rules="[rules.required]"
              :placeholder="$t('login.namePlaceholder')"
              @keydown.enter.exact="signup"
              v-model="signupForm.name"
            ></v-text-field>
            <v-text-field
              :disabled="signupLoading"
              :loading="signupLoading"
              :rules="[rules.required]"
              :placeholder="$t('login.phonePlaceholder')"
              @keydown.enter.exact="signup"
              v-model="signupForm.telephone"
            ></v-text-field>
            <v-btn
              :loading="signupLoading"
              :disabled="!signupValid"
              class="btn-login mt-4"
              color="primary"
              depressed
              @click="signup"
            >
              {{ $t("login.signUp") }}
            </v-btn>
          </v-form>
          <div class="d-flex flex-column mt-4">
            <span>{{ $t("login.haveAnAccount") }}</span>
            <span
              v-ripple
              style="text-decoration: underline; cursor:pointer;"
              @click="isSignUp = false"
            >
              {{ $t("login.plsClickHereToLogIn") }}
            </span>
          </div>
        </div>
        <div
          class="d-flex flex-column ai-center jc-between h-75 w-100"
          :class="{ hide: !forgetPwd }"
        >
          <v-form class="login-form" v-model="forgetValid">
            <v-text-field
              :disabled="forgetLoading"
              :loading="forgetLoading"
              :rules="[rules.required, rules.validEmail]"
              :placeholder="$t('login.forgetPasswordPlaceholder')"
              v-model="forgetPasswordAccount"
            ></v-text-field>
            <v-btn
              :loading="forgetLoading"
              :disabled="!forgetValid"
              class="btn-login mt-4"
              color="primary"
              depressed
              @click="postForgetPwd"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-form>
          <div class="d-flex flex-column mt-4">
            <span
              v-ripple
              style="text-decoration: underline; cursor:pointer;"
              @click="forgetPwd = false"
            >
              {{ $t("login.plsClickHereToLogIn") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import VFacebookLogin from "vue-facebook-login-component";
import { createSocket } from "@/plugins/websocket";
export default {
  components: { VFacebookLogin },
  data() {
    return {
      googleSignInParams: {
        clientId: process.env.VUE_APP_GOOGLE_APP_ID
      },
      FBmodel: {},
      FB: {},
      FBAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
      FBOptions: { cookie: true },
      FBscope: {},
      loginLoading: false,
      signupLoading: false,
      forgetLoading: false,
      signupValid: false,
      forgetValid: false,
      loginForm: {
        account: "",
        password: ""
      },
      signupForm: {
        account: "",
        password: "",
        repeatPassword: "",
        name: "",
        telephone: "",
        thirdParty: false,
        accessToken: ""
      },
      forgetPasswordAccount: "",
      error409: "",
      conflictAccount: "",
      isSignUp: false,
      forgetPwd: false,
      rules: {
        required: value => !!value || this.$t("errorMessage.required"),
        repeatPwd: value =>
          value === this.signupForm.password ||
          this.$t("errorMessage.repeatPassword"),
        validPwd: value =>
          /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,30}$/.test(value) ||
          this.$t("errorMessage.passwordFormatAndLength"),
        validEmail: value =>
          /.+@.+\..+/.test(value) ||
          this.$t("errorMessage.invalidAccountFormat")
      }
    };
  },
  computed: {
    ...mapState(["signInDialog"])
  },
  methods: {
    ...mapMutations("signInDialog", { setDialogVisible: "setVisible" }),
    ...mapMutations("user", ["checkCookie"]),
    ...mapActions("user", ["getAvatar"]),
    ...mapActions("snackbar", ["openSnackbar"]),
    async handleSdkInit({ FB, scope }) {
      this.loginLoading = true;
      this.FB = FB;
      await scope.logout();
      this.FBscope = scope;
      this.loginLoading = false;
    },
    async fbLogin() {
      this.loginLoading = true;
      if (!this.FBmodel.connected) await this.FBscope.login();
      if (this.FBmodel.connected) {
        const body = {
          accessToken: this.FB.getAccessToken(),
          thirdParty: "facebook"
        };
        await this.thirdPartyLogin(body);
      } else console.log("qq");
    },
    async googleSignInSuccess(googleUser) {
      this.loginLoading = true;
      const body = {
        accessToken: googleUser.getAuthResponse().id_token,
        thirdParty: "google"
      };
      await this.thirdPartyLogin(body);
    },
    googleSignInError(error) {
      console.log(error);
    },
    async thirdPartyLogin(body) {
      const res = await this.$http.post("thirdParty", body);
      if (!res.data.isExist) {
        this.signupForm.account = res.data.email;
        this.signupForm.name = res.data.name;
        this.signupForm.thirdParty = body.thirdParty;
        this.signupForm.accessToken = body.accessToken;
        this.isSignUp = true;
      } else {
        this.afterLogin();
      }
    },
    checkConflict() {
      if (this.conflictAccount === this.signupForm.account)
        this.error409 = this.$t("errorMessage.accountConflict");
      else this.error409 = "";
    },
    async login() {
      this.loginLoading = true;
      let success = true;
      await this.$http.post("signin", this.loginForm).catch(() => {
        this.openSnackbar({
          msg: this.$t("login.failed"),
          color: "error"
        });
        success = false;
        this.loginLoading = false;
      });
      if (success) {
        this.afterLogin();
      }
    },
    async afterLogin() {
      this.openSnackbar({
        msg: this.$t("login.success"),
        color: "success"
      });
      this.setDialogVisible(false);
      this.checkCookie();
      createSocket(this.getWSURL());
      await this.getAvatar();
      if (this.signInDialog.afterLogin === "design")
        this.$router.push(`/${this.$i18n.locale}/design`);
      this.loginLoading = false;
      this.$forceUpdate();
    },
    async signup() {
      this.signupLoading = true;
      await this.$http
        .post("signup", this.signupForm)
        .then(() => {
          this.openSnackbar({
            msg: this.$t("login.signupSuccess"),
            color: "success"
          });
          this.isSignUp = false;
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.error409 = this.$t("errorMessage.accountConflict");
            this.conflictAccount = this.signupForm.account;
          }
          this.openSnackbar({
            msg: this.$t("login.signupFailed"),
            color: "error"
          });
        });
      this.signupLoading = false;
    },
    clickSignUp() {
      this.signupForm.thirdParty = null;
      this.signupForm.accessToken = null;
      this.isSignUp = true;
    },
    async postForgetPwd() {
      this.forgetLoading = true;
      await this.$http
        .post("forgetpassword", {
          account: this.forgetPasswordAccount
        })
        .then(() => {
          this.openSnackbar({
            msg: this.$t("login.forgetPasswordResult"),
            color: "success"
          });
        });
      this.forgetLoading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
::v-deep .custom-dialog
  font-size: 0.85rem !important
  border-radius: 1rem
  height: 40rem
  background: #181C24
  .login-dialog
    height: 100%
  .login-logo
    background-image: url('/assets/bg/card_login_png.png')
    background-size: 100% 100%
    width: 25rem
  .login
    background: white
    .login-title
      margin-top: 4rem
      font-size: 2rem
    .login-form
      margin-top: 5rem
      width: 20rem
      .btn-login
        font-size: 17px
        height: 2.2rem
        width: 100%
.hide
  display: none !important
</style>
